/*!
 * Render product option selectors
 */ import { h } from 'preact';
import { useState } from 'preact/hooks';
import cls from 'clsx';
import $ from 'jquery';
import { genUid } from '../../../uid';
import { kebabCase } from '../../../string/kebab-case';
export const ProductOptionsAsDropdown = function({ optionNames , optionValueGroups , dispatch , focusOnIndex , productId  }) {
    const [uid] = useState(genUid);
    return h('div', {
        className: 'ProductSelect'
    }, optionNames.map(function(optionName, optionIndex) {
        const optionGroup = optionValueGroups[optionIndex];
        if (optionGroup == null) {
            return null;
        }
        return h('div', {
            key: kebabCase(uid + optionName),
            className: cls('ProductSelect-group')
        }, h('select', {
            className: cls('ProductSelect-groupTitle'),
            id: kebabCase(`${'js-select'}-${productId}-${optionIndex}`),
            onFocus: function() {
                focusOnIndex(optionIndex);
            },
            onClick: function() {
                focusOnIndex(optionIndex);
            },
            onChange: function() {
                focusOnIndex(optionIndex);
            },
            onInput: function() {
                const rawOptionName = $('#js-select-' + productId + '-' + optionIndex).val();
                const inputOptionName = typeof rawOptionName === 'string' ? rawOptionName : null;
                if (inputOptionName == null) {
                    return;
                }
                dispatch({
                    type: 'SelectOption',
                    payload: {
                        optionIndex,
                        optionValue: inputOptionName
                    }
                });
            }
        }, [
            optionGroup.filter(({ status  })=>{
                return status !== 'unavailable';
            }).map(function(optionValue) {
                const { status  } = optionValue;
                const name = kebabCase(`${uid}-${optionName}`);
                const id = kebabCase(`${name}-${optionValue.name}`);
                return h('option', {
                    id,
                    name,
                    selected: status === 'selected',
                    value: optionValue.name
                }, optionValue.name);
            })
        ]));
    }));
};
